import dayjs from "dayjs";

import { Data } from "./types";

import { IPublisher } from "@/api/types/publisher";

export function createData(data: IPublisher): Data {
    const {
        id,
        updatedAt,
        createdAt,
        title,
        contentCount,
        isActive,
        contactName,
        contactPhone,
        contactEmail,
        contactPosition,
    } = data;

    return {
        id,
        title: title || "",
        isActive,
        contentCount: String(contentCount) || "-",
        contactName: contactName || "-",
        contactPhone: contactPhone || "-",
        contactEmail: contactEmail || "-",
        contactPosition: contactPosition || "-",
        createdAt: dayjs(createdAt).format("YYYY-MM-DD HH:mm"),
        updatedAt: dayjs(updatedAt).format("YYYY-MM-DD HH:mm"),
    };
}
